import axios from 'axios';

import {
  BIZ_DEV_API_URL,
  BIZ_LIVE_API_URL,
  BIZ_TEST_API_URL,
  COMMON_DEV_API_URL,
  COMMON_LIVE_API_URL,
  COMMON_TEST_API_URL,
  IMAGE_DEV_API_URL,
  IMAGE_LIVE_API_URL,
  IMAGE_TEST_API_URL,
} from './ConstantApi';
import { ResStatus } from './enum';

export const getCommonAPIURL = () => {
  if (window.location.href.includes('https://dev-')) {
    return COMMON_DEV_API_URL;
  } else if (window.location.href.includes('https://test-')) {
    return COMMON_TEST_API_URL;
  } else if (window.location.href.includes('https://')) {
    return COMMON_LIVE_API_URL;
  } else {
    return COMMON_DEV_API_URL;
  }
};

export const getImageAPIURL = () => {
  if (window.location.href.includes('https://dev-')) {
    return IMAGE_DEV_API_URL;
  } else if (window.location.href.includes('https://test-')) {
    return IMAGE_TEST_API_URL;
  } else if (window.location.href.includes('https://')) {
    return IMAGE_LIVE_API_URL;
  } else {
    return IMAGE_DEV_API_URL;
  }
};
export const getAPIURL = () => {
  if (window.location.href.includes('https://dev-')) {
    return BIZ_DEV_API_URL;
  } else if (window.location.href.includes('https://test-')) {
    return BIZ_TEST_API_URL;
  } else if (window.location.href.includes('https://')) {
    return BIZ_LIVE_API_URL;
  } else {
    return BIZ_DEV_API_URL;
  }
};

const axiosInstance = axios.create({
  baseURL: getAPIURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

type AxiosParams = {
  access_token: string;
  device_type: number;
  command: any;
};
type FetchParams = {
  method: string;
  headers: any;
  body: any;
};

export const getAxiosRequestData = (data: any): AxiosParams => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    access_token: accessToken ? accessToken : '',
    device_type: 0, // 0(IOS) / 1 (ANDROID)
    command: data,
  };
};
export const getFetchRequestData = (data: any): FetchParams => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      access_token: accessToken ? accessToken : '',
      device_type: 0,
      command: data,
    }),
  };
};

export const queryApi = async (url: string, data: any) => {
  const requestData = await getAxiosRequestData(data);
  console.log('query : ', url, data, requestData);

  return axiosInstance.post(url, requestData).then((response) => {
    console.log('response : ', response.data);

    if (response.data.access_token && response.data.access_token !== '') {
      localStorage.setItem('accessToken', response.data.access_token);
    }
    if (response.data.status === ResStatus.RES_UNAUTHORIZED) {
      localStorage.setItem('accessToken', '401');
    }
    // else {
    //     localStorage.setItem(
    //         "accessToken",
    //         "d5980fb5e72665a9ebbc1856a0afc9f76a7f252d"
    //     );
    // }
    return response.data;
  });
};
export const imageApi = async (url: string, data: any) => {
  const requestData = await getFetchRequestData(data);
  return fetch(`${getImageAPIURL()}/${url}`, requestData).then((res) => {
    return res.json();
  });
};

export default axiosInstance;
